import { HStack, Stack, Image, Text, VStack, useColorMode, Button } from '@chakra-ui/react'
import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FiCalendar } from 'react-icons/fi'
import { getTokens } from '../../config/colorTokens'

const Volunteer = (props) => {
	const { colorMode } = useColorMode()
	const [show, setShow] = useState(false)
	const t = getTokens(colorMode)

	return (
			<motion.div
				variants={props.variants}
				whileHover={{
					scale: 1.02,
					transition: { type: 'spring', stiffness: 300, damping: 20 }
				}}>
				<Stack direction={{ base: 'column', md: 'row' }}>
					<HStack
						alignItems="start"
						border="1px"
						borderRadius="10px"
						borderColor={t.borderCard}
						backdropFilter={'blur(5px)'}
						width="100%"
						p={4}>
						<Image
							mt={1}
							style={{ height: '60px', width: '60px' }}
							borderRadius="10px"
							src={props.logo}
						/>
						<VStack alignItems="left" spacing={0} p={0}>
							<Text fontSize="md" fontWeight="bold">
								{props.role}
							</Text>
							<Text fontSize="sm" fontWeight="semibold">
								{props.company}
							</Text>
							<Text color={t.textMuted} fontSize="sm" display="flex" alignItems="center">
								<FiCalendar />
								&nbsp;{props.date}
							</Text>
							{props.description.length > 0 && (
								<Button
									variant="link"
									w="fit-content"
									size="sm"
									colorScheme="facebook"
									_active={{ color: 'none' }}
									onClick={() => setShow(!show)}>
									{show ? 'Hide Details' : 'Show Details'}
								</Button>
							)}
							{show &&
								props.description.map((d, i) => {
									return (
										<Text fontSize="sm" key={i}>
											• {d}
										</Text>
									)
								})}
						</VStack>
					</HStack>
				</Stack>
				</motion.div>
	)
}

export default Volunteer
